__turbopack_context__.v({
  "actions": "pdf-scan-module__yaBG4G__actions",
  "container": "pdf-scan-module__yaBG4G__container",
  "date": "pdf-scan-module__yaBG4G__date",
  "empty": "pdf-scan-module__yaBG4G__empty",
  "filename": "pdf-scan-module__yaBG4G__filename",
  "glassCard": "pdf-scan-module__yaBG4G__glassCard",
  "header": "pdf-scan-module__yaBG4G__header",
  "jobCard": "pdf-scan-module__yaBG4G__jobCard",
  "jobInfo": "pdf-scan-module__yaBG4G__jobInfo",
  "jobList": "pdf-scan-module__yaBG4G__jobList",
  "jobStatus": "pdf-scan-module__yaBG4G__jobStatus",
  "jobsSection": "pdf-scan-module__yaBG4G__jobsSection",
  "percentage": "pdf-scan-module__yaBG4G__percentage",
  "progressBar": "pdf-scan-module__yaBG4G__progressBar",
  "progressContainer": "pdf-scan-module__yaBG4G__progressContainer",
  "progressFill": "pdf-scan-module__yaBG4G__progressFill",
  "progressLabel": "pdf-scan-module__yaBG4G__progressLabel",
  "scanBtn": "pdf-scan-module__yaBG4G__scanBtn",
  "spin": "pdf-scan-module__yaBG4G__spin",
  "subtitle": "pdf-scan-module__yaBG4G__subtitle",
  "tagCompleted": "pdf-scan-module__yaBG4G__tagCompleted",
  "tagFailed": "pdf-scan-module__yaBG4G__tagFailed",
  "tagProcessing": "pdf-scan-module__yaBG4G__tagProcessing",
  "tagQueued": "pdf-scan-module__yaBG4G__tagQueued",
  "title": "pdf-scan-module__yaBG4G__title",
  "viewBtn": "pdf-scan-module__yaBG4G__viewBtn",
});
